import React, { useEffect, useState } from "react"
import Letter from "./Letter";

import axiosClient from './axiosClient';
import { devlogAPIURL } from "../APIurl";
import CryptoJs from 'crypto-js';
import isLoggedIn from "./isLoggedIn";

// const letterArr: ILetter[] = [
//     {
//         header: "string",
//         body: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Non quos nobis sapiente laboriosam quas, iusto reprehenderit blanditiis magni hic eligendi laborum incidunt. Cum temporibus explicabo a iure minima minus voluptatum. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Non quos nobis sapiente laboriosam quas, iusto reprehenderit blanditiis magni hic eligendi laborum incidunt. Cum temporibus explicabo a iure minima minus voluptatum.",
//         tags: [],
//         comments: [],
//         date: new Date(),
//         attachments: [{
//             type: "image",
//             content: "https://th.bing.com/th?id=OSK.HEROzRohN8iJ9Uq4ExW5aBFHDlK9iSgdx5lIj8qjQGEc390&w=472&h=280&c=13&rs=2&o=6&dpr=1.3&pid=SANGAM"
//         },
//         {
//             type: 'video',
//             content: "https://media.geeksforgeeks.org/wp-content/uploads/20210314115545/sample-video.mp4"
//         }],
//     }, {
//         header: "string",
//         body: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Non quos nobis sapiente laboriosam quas, iusto reprehenderit blanditiis magni hic eligendi laborum incidunt. Cum temporibus explicabo a iure minima minus voluptatum.orem ipsum dolor, sit amet consectetur adipisicing elit. Non quos nobis sapiente laboriosam quas, iusto reprehenderit blanditiis magni hic eligendi laborum incidunt. Cum temporibus explicabo a iure minima minus voluptatum.",
//         tags: [],
//         comments: [],
//         date: new Date(),
//         attachments: [],
//     }
// ]

const Letters = props => {
    const [allLetters, setAllLetters] = useState([]);
    const [allOGLetters, setAllOGLetters] = useState([]);
    const [excludeDreams, setexcludeDreams] = useState(false);
    const [pinLetters, setpinLetters] = useState(true);

    const onExcludeDreams = () => {
        let currVal = false;
        setexcludeDreams((prevVal) => {
            currVal = !prevVal;
            console.log('currval', currVal);

            setAllLetters(currVal ? allOGLetters.filter(i => !i?.tags?.includes("dream")) : allOGLetters);
            return currVal;
        });

    };
    const onPin = () => {
        let currVal = false;
        setpinLetters((prevVal) => {
            currVal = !prevVal;
            return currVal;
        });

    };
    

    useEffect(() => {

        setTimeout(() => {
            (async function () {
                try {
                    const letterItemsResp = await axiosClient.get(`${devlogAPIURL}/dreamItems`);
                    // console.log('response', letterItemsResp);
                    const letterItems = JSON.parse(CryptoJs.AES.decrypt(letterItemsResp.data.johSamajhnaHoSamajhLe, process.env.REACT_APP_SECRET_KEY).toString(CryptoJs.enc.Utf8));
                    // console.log('decrypted', letterItems)
                    //  console.log('sorted',letterItems.sort((i:any, j:any) => ((i.originalDate as string)).localeCompare((j.originalDate)) ))

                    const sorted = letterItems.sort((i, j) => ((j.originalDate)).localeCompare((i.originalDate)));
                    // const sorted = letterItems.sort((i:any, j:any) => (new Date(i.originalDate)) > (new Date(j.originalDate)) );
                    // console.log('letter', sorted)
                    setAllLetters(sorted);
                    setAllOGLetters(sorted);
                } catch (error) {
                    return {
                        error
                    };
                }
            })();
        }, 1000);

    }, [])


    return isLoggedIn() ? (
        <div className="letters-container text-center color-white">
            <div className="letters-container1">
                <div className="letters-container2">
                    <div className="black-film">
                        <h3>Letters</h3>
                        <p>...that I'd share with you had you been here. </p>
                        <hr style={{ width: "35%", left: "34%", position: "relative" }} />
                        <span className={`${!excludeDreams ? 'button-filled' : ''} search-button-filter`} onClick={onExcludeDreams}> Show all </span>
                        <span className={`${excludeDreams ? 'button-filled' : ''} search-button-filter`} onClick={onExcludeDreams}> Exclude Dreams </span>
                        <span className={`padding-left-1x ${pinLetters ? 'button-filled' : ''} search-button-filter`} onClick={onPin}> { pinLetters? 'Remove Pin' : 'Show pinned on top'} </span>
                        <hr style={{ width: "35%", left: "34%", position: "relative" }} />
                    </div>
                    {
                        pinLetters ? <div className="letter-container w-35 " >
                            Pinned ones
                            {allLetters.filter(i => i.tags.includes("pin")).map((letter, i) => {
                                return <Letter key={i} letter={letter} pinned={true} />
                            })}
                            <hr style={{ width: "35%", left: "34%", position: "relative" }} />
                        </div> : <></>
                    }


                    <div className="letter-container w-35 padding-bottom-2x" >
                        {allLetters.map((letter, i) => {
                            return <Letter key={i} letter={letter} pinned={false} />
                        })}
                    </div>
                </div>
            </div>
        </div>
    ) :
        <>Apna naam bataao..</>
}

export default Letters
